const translations = {
  "en": {
    "Current Price": "Current Price"
  },
  "zh-tw": {
    "Current Price": "目前價格"
  }
};

export default translations;
